import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";

function CarouselLogo() {

  const posts = [
     {
      "id": 7,
      "is_active": true,
      "created_date": "2024-09-10T12:50:07.836Z",
      "last_modified_date": "2024-09-16T14:35:32.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "PillTime",
      "designation": "",
      "organisation": "PillTime",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/PillTimenew_CAROUSEL.png",
      "content": ""
    },
      {

      "id": 1,
      "is_active": true,
      "created_date": "2024-03-05T19:20:54.423Z",
      "last_modified_date": "2024-09-16T14:34:05.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Claude-Alain Danthe",
      "designation": "World YMCA",
      "organisation": "Digital Head",
      "photo": "https://backendtestinternal.s3.amazonaws.com/Claude-Alain%20Danthe.jpg",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/YMCALOGO_CAROUSEL.png",
      "content": "We work with Antrazal since they started. They really boost our use of the Salesforce environment. Their major strength: they really put at the maximum the build in features of Salesforce without trying to force us to buy costly third-party solution. They are fantastic to clarify and understand the requirements and even anticipate them. The most fantastic achievement, they build in a voting system for our General Assembly! A master piece that save us hours of work."
    },
    {
      "id": 14,
      "is_active": true,
      "created_date": "2026-02-17T08:23:18.716Z",
      "last_modified_date": "2026-02-17T08:45:40.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Trivago",
      "designation": "",
      "organisation": "Trivago",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/trivago.png",
      "content": ""
    },
    {
      "id": 15,
      "is_active": true,
      "created_date": "2026-02-17T08:46:42.510Z",
      "last_modified_date": "2026-02-17T09:31:35.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Stanley Martin Homes",
      "designation": "",
      "organisation": "Stanley Martin Homes",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/header.webp",
      "content": ""
    },
  
    {
      "id": 2,
      "is_active": true,
      "created_date": "2024-03-06T06:07:58.244Z",
      "last_modified_date": "2025-11-11T17:43:51.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Vladimira K. Jackson",
      "designation": "Service Operations Manager",
      "organisation": "Swirl Card, Ireland",
      "photo": "https://backendtestinternal.s3.amazonaws.com/unnamed.webp",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/unnamed.webp",
      "content": "Antrazal was an exceptional partner during a critical phase of our Salesforce Marketing Cloud project. Their expertise and responsiveness allowed us to overcome resource challenges and keep the project on track. We highly value their professionalism and would gladly work with them again."
    },
    {
      "id": 3,
      "is_active": true,
      "created_date": "2024-03-06T06:48:41.495Z",
      "last_modified_date": "2024-09-16T14:34:41.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Aaron Knopp",
      "designation": "President",
      "organisation": "E-Z Anchor Puller Mfg. Co.",
      "photo": "https://backendtestinternal.s3.amazonaws.com/Aaron%20Knopp.jpeg",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/EZ_LOGO_CAROUSEL.png",
      "content": "The team at Antrazal have been a pleasure to work with. They are very knowledgeable, professional and has offered many suggestions to improve my marketing cloud automation. The work is accurate and fast, I will continue to work with them!"
    },
    {
      "id": 6,
      "is_active": true,
      "created_date": "2024-09-10T12:49:42.844Z",
      "last_modified_date": "2024-09-16T14:35:15.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Elements",
      "designation": "",
      "organisation": "Elements",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/Elements%20Group_CAROUSEL.png",
      "content": ""
    },
   
    {
      "id": 8,
      "is_active": true,
      "created_date": "2024-09-10T12:50:43.792Z",
      "last_modified_date": "2024-09-16T14:35:45.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Flute Center",
      "designation": "",
      "organisation": "Flute Center",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/Flute%20Center_CAROUSEL.png",
      "content": ""
    },
    {
      "id": 9,
      "is_active": true,
      "created_date": "2024-09-10T12:55:30.352Z",
      "last_modified_date": "2024-09-16T14:36:00.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Block earner",
      "designation": "",
      "organisation": "Block earner",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/BLACK_EARNER_CAROUSEL.png",
      "content": ""
    },
    {
      "id": 10,
      "is_active": true,
      "created_date": "2024-09-10T13:11:08.203Z",
      "last_modified_date": "2024-09-16T14:36:17.000Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Discovery-place",
      "designation": "Discovery-place",
      "organisation": "",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/Discovery%20Place_CAROUSEL.png",
      "content": ""
    },
    {
      "id": 11,
      "is_active": true,
      "created_date": "2024-09-24T12:26:26.734Z",
      "last_modified_date": "2024-09-24T12:26:26.734Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "United Wheels",
      "designation": "",
      "organisation": "",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/United_Wheels_Primary_Logo_Blue.png",
      "content": ""
    },
    {
      "id": 12,
      "is_active": true,
      "created_date": "2026-02-10T05:54:06.313Z",
      "last_modified_date": "2026-02-10T05:54:06.313Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Motus Group",
      "designation": "",
      "organisation": "Motus Group",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/logo.png",
      "content": ""
    },
    {
      "id": 13,
      "is_active": true,
      "created_date": "2026-02-10T05:55:20.327Z",
      "last_modified_date": "2026-02-10T05:55:20.327Z",
      "updatedBy": "1",
      "createdBy": "1",
      "client_name": "Debt Consultants Group",
      "designation": "",
      "organisation": "Debt Consultants Group",
      "photo": "",
      "organisation_logo": "https://backendtestinternal.s3.amazonaws.com/dcg-logo.png",
      "content": ""
    },

  ]

  const duplicatedPosts = [...posts, ...posts];
  const extractImageName = (url) => {
    if (!url) return "Unknown Image";
    const parts = url.split("/");
    return parts[parts.length - 1].split(".")[0];
  };
  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div className="container">
        <AppContainer>
          <Wrapper>
            <Marquee>
              <MarqueeGroup>
                {duplicatedPosts.map((currentElement, index) => {
                  const { id, organisation_logo } = currentElement;
                  return (
                    <ImageGroup key={index ? index : `logo-${index}`}>
                      <Image src={organisation_logo} alt={extractImageName(organisation_logo || '')} />
                    </ImageGroup>
                  );
                })}
              </MarqueeGroup>
            </Marquee>
          </Wrapper>
        </AppContainer>

      </div>

    </div>
  );
}

export default CarouselLogo;

const AppContainer = styled.div`
  color: #000000;
  height: 15vh;
  padding-top:4rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 780px) {
    height: 15vh;
    display:none;
  }
      @media (max-width: 1600px) {
    height: 20vh;
  }
`;
const BottomColorDiv = styled.div`
  height: 1vh;
  // background-color:red;
  width:100%;
  display:grid;

grid-template-columns: repeat(3,1fr);
  
  `;

const Wrapper = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 580px) {
    height: 100%;
  }
`;

const Marquee = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  user-select: none;
    will-change: transform;
`;

const scrollX = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%); /* Adjust to scroll halfway, then loop */
  }
`;

const common = css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  white-space: nowrap;
  animation: ${scrollX} 20s linear infinite;
  will-change: transform;
`;

const MarqueeGroup = styled.div`
  ${common}
`;

const ImageGroup = styled.div`
  display: grid;
  place-items: center;
`;

const Image = styled.img`
  height: 50px;
  margin: 0 30px;
  max-width: 225px;

  @media (max-width: 580px) {
    height: 40px;
    margin: 0 20px;
  }
`;
